import { SvgBase } from "../svg.base";

export const Calendar = () => (
  <SvgBase
    width="20"
    height="20"
    viewBox="0 0 20 20">
    <g
      fill="none"
      fillRule="evenodd"
      stroke="currentColor"
      strokeLinejoin="round"
      strokeWidth="1.5"
    >
      <path
        strokeLinecap="round"
        d="M1.563 4.938c0-.622.503-1.125 1.125-1.125h14.625c.62 0 1.125.503 1.125 1.124v12.375c0 .622-.504 1.125-1.125 1.125H2.688a1.124 1.124 0 0 1-1.125-1.125V4.938z"
      />
      <path d="M1.563 8.313h16.875" />
      <path
        strokeLinecap="round"
        d="M6.063 5.5V1.562M13.938 5.5V1.562M5.219 11.125a.281.281 0 1 0 0 .563.281.281 0 0 0 0-.563M5.219 15.063a.281.281 0 1 0 0 .562.281.281 0 0 0 0-.563M10 11.125a.281.281 0 1 0 0 .563.281.281 0 0 0 0-.563M10 15.063a.281.281 0 1 0 0 .562.281.281 0 0 0 0-.563M14.781 11.125a.281.281 0 1 0 0 .563.281.281 0 0 0 0-.563M14.781 15.063a.281.281 0 1 0 0 .562.281.281 0 0 0 0-.563"
      />
    </g>
  </SvgBase>
);